import React, { Component } from 'react';
import { database } from '../firebase';
import _ from 'lodash';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import renderHTML from 'react-render-html';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      body: '',
      posts: []
    };
    // bind
    this.onHandleChange = this.onHandleChange.bind(this);
    this.onHandleSubmit = this.onHandleSubmit.bind(this);
  }

  // lifecycle
  componentDidMount() {
    // Get Posts
    const posts = [];

    database.collection('posts').get().then((snapshot) => {
        snapshot.docs.forEach(doc => {
     
          posts.push({
            id: doc.id,
            title: doc.data().title,
            body: doc.data().body
          });

        });

        this.setState({ posts }, () => {
          console.log("Posts are: " + this.state.posts)
        });

      });

  }

  // render posts from firebase
  renderPosts() {

   this.state.posts.forEach(doc => {
      // Render whatever data is in your document
      return ( 
        <p> { JSON.stringify(doc.title) } </p>

      )
    })
  }

  onHandleChange(e) {
    this.setState({ body: e });
    console.log(this.state.body);
  }

  onHandleSubmit(e) {
    e.preventDefault();
    const post = {
      title: this.state.title,
      body: this.state.body
    };

    //Handle Post   
    const userRef = database.collection('posts').add(post);  

    this.setState({
      title: '',
      body: ''
    });
  }

  render() {

    var rows = this.state.posts.map(function (post, i) {
      return <div>
                <h3> {post.title} </h3>
                <p> { renderHTML(post.body) } </p>
            </div>;
    });

    console.log("Running render for Posts with "+rows.length+" rows");

    return (
      <div>
      
        <section class="content-section" id="portfolio">
          <div class="container">
            <div class="content-section-heading text-center">
              <h2 class="mb-5">Posts</h2>
            </div>

            <div>{rows}</div>
          </div>
        </section>
        <br />

        <section id="newpost" class="content-section bg-primary text-white">
          <div class="container text-center">
            <h2 class="mb-4">New Post</h2>
            <div className="container">
              <form onSubmit={this.onHandleSubmit}>
                <div className="form-group">
                  <input
                    value={this.state.title}
                    type="text"
                    name="title"
                    placeholder="Title"
                    onChange={e => {
                      this.setState({ title: e.target.value });
                    }}
                    ref="title"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <ReactQuill
                    modules={App.modules}
                    formats={App.formats}
                    value={this.state.body}
                    placeholder="Body"
                    onChange={this.onHandleChange}
                  />
                </div>
                <button className="btn btn-primary">Post</button>
              </form>
              
            </div>
          </div>
        </section>
      </div>
    );
  }
}

App.modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image', 'video'],
    ['clean'],
    ['code-block']
  ]
};

App.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'link',
  'image',
  'video',
  'code-block'
];

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js